import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDoc } from "../hooks/useDoc";
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";

const renderBloques = (descripcionLarga) => {
  if (!descripcionLarga) return null;

  if (Array.isArray(descripcionLarga)) {
    return descripcionLarga.map((bloque, i) => {
      if (bloque.type === 'image') {
        return <img key={i} src={bloque.url} alt="" className="evento-img-inline" />;
      }
      if (bloque.imagen) {
        return <img key={i} src={bloque.imagen} alt="" className="evento-img-inline" />;
      }
      const text = bloque.content ?? bloque;
      return String(text).split(/\n\s*\n/).map((p, j) => <p key={`${i}-${j}`}>{p}</p>);
    });
  }

  return String(descripcionLarga).split(/\n\s*\n/).map((p, i) => <p key={i}>{p}</p>);
};

const EventoDetalle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: evento, loading } = useDoc('eventos', slug);

  if (loading) return <section className="section"><div className="container"><p>Cargando...</p></div></section>;
  if (!evento) return <section className="section"><div className="container"><p>Evento no encontrado</p></div></section>;

  return (
    <section className="section">
      <div className="container">
        <button onClick={() => navigate(-1)} className="form-button" style={{ marginBottom: "1.5rem" }}>
          ← Volver
        </button>

        <img src={evento.imagen} alt={evento.titulo} className="section-image" />
        <h2 className="section-title">{evento.titulo}</h2>
        <p className="contact-heading">{evento.descripcionCorta}</p>

        <div className="taller-detalle-texto">
          {renderBloques(evento.descripcionLarga)}
        </div>

        <div className="taller-detalle-ficha">
          <div><strong><FaCalendarAlt /></strong> {evento.fecha}</div>
          <div><strong><FaClock /></strong> {evento.hora}</div>
          <div><strong><FaMapMarkerAlt /></strong> {evento.lugar}</div>
        </div>

        {evento.link && (
          <a href={evento.url} target="_blank" rel="noopener noreferrer" className="form-button red-button">
            {evento.link}
          </a>
        )}
      </div>
    </section>
  );
};

export default EventoDetalle;
